import { render, staticRenderFns } from "./PdfTemplateAttachments.vue?vue&type=template&id=3729332e&scoped=true"
import script from "./PdfTemplateAttachments.vue?vue&type=script&lang=js"
export * from "./PdfTemplateAttachments.vue?vue&type=script&lang=js"
import style0 from "./PdfTemplateAttachments.vue?vue&type=style&index=0&id=3729332e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3729332e",
  null
  
)

export default component.exports